import React, { FC, useEffect, useState } from 'react';
import { getDatePickerFormat, getDateFnsLocale } from 'utils/format';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'react-i18next';
import { transportDateHelper } from 'utils/transport-date-helper';
import { TransportServices } from 'models/transport';

type TransportDatePickerProps = {
    date: Date | null;
    onDateChange: (date: Date | null) => void;
    type: TransportServices;
};
const TransportDatePicker: FC<TransportDatePickerProps> = ({ date, onDateChange, type }: TransportDatePickerProps) => {
    const { t: translate } = useTranslation(['common', 'transport']);
    const [selectedDate, setSelectedDate] = useState<Date | null>();

    useEffect(() => {
        const firstValidTransportDate = transportDateHelper.nextWorkingDay(new Date());
        if (!date) {
            dateChanged(firstValidTransportDate);
            return;
        }
        dateChanged(date);
    }, []);

    const dateChanged = (date: Date | string | null) => {
        if (date !== null && date.toString() !== 'Invalid Date') {
            setSelectedDate(date as Date);
            onDateChange(date as Date);
            return;
        }
        setSelectedDate(null);
        onDateChange(null);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale()}>
            <DatePicker
                format={getDatePickerFormat()}
                minDate={new Date()}
                shouldDisableDate={transportDateHelper.transportDisabledDates}
                value={selectedDate}
                onChange={dateChanged}
                label={
                    type === TransportServices.PICKUP
                        ? translate('transport:TRANSPORT_PICKUP_DATE')
                        : translate('transport:TRANSPORT_DELIVERY_DATE')
                }
            />
        </LocalizationProvider>
    );
};

export default TransportDatePicker;
